/* Fame Stoned 2027 — tema betiği
   Bölümler kendi verilerini <script type="application/json" data-fs-veri> içinde verir;
   kök elemanda data-fs="<modül adı>" bulunur. Aşağıdaki MODUL sözlüğü onları başlatır. */
(function () {
  'use strict';

  var W = window;
  var FS = W.FS = W.FS || {};

  /* ---------------- dil ----------------
     Ekran metinleri theme.liquid içindeki FS.m nesnesinden gelir (locales/*.json).
     Anahtar bulunamazsa ikinci argüman kullanılır — yani dil dosyası eksik olsa
     bile arayüz hiçbir zaman boş kalmaz. */
  FS.t = function (anahtar, yedek) {
    var m = FS.m;
    return (m && typeof m[anahtar] === 'string' && m[anahtar]) || yedek;
  };

  FS.azalt = false;
  try { FS.azalt = W.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------------- para ---------------- */
  function basamakla(sayi, ayrac, nokta) {
    var p = sayi.toFixed(2).split('.');
    return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ayrac) + nokta + p[1];
  }
  FS.para = function (kurus) {
    var k = (kurus || 0) / 100;
    var kalip = FS.paraKalip || '{{amount_with_comma_separator}} ₺';
    return kalip.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, ad) {
      if (ad === 'amount_with_comma_separator') return basamakla(k, '.', ',');
      if (ad === 'amount_no_decimals') return Math.round(k).toLocaleString('tr-TR');
      if (ad === 'amount_no_decimals_with_comma_separator') return Math.round(k).toLocaleString('de-DE');
      return basamakla(k, ',', '.');
    });
  };
  // Mağazanın kendi para biçimi (theme.liquid'den gelir); yoksa TL varsayılanı.
  FS.paraKalip = FS.paraKalip || '{{amount_with_comma_separator}} ₺';

  /* ---------------- küçük yardımcılar ---------------- */
  function el(id) { return document.getElementById(id); }
  function q(kok, s) { return kok.querySelector(s); }
  function qa(kok, s) { return Array.prototype.slice.call(kok.querySelectorAll(s)); }
  function veri(kok) {
    var e = q(kok, '[data-fs-veri]');
    if (!e) return {};
    try { return JSON.parse(e.textContent); } catch (x) { return {}; }
  }
  FS.el = el;

  /* ---------------- bildirim ---------------- */
  var bildirimZaman;
  FS.bildir = function (metin, bagAd, bagUrl) {
    var b = el('fsBildirim');
    if (!b) {
      b = document.createElement('div');
      b.id = 'fsBildirim';
      b.className = 'bildirim';
      b.setAttribute('role', 'status');
      document.body.appendChild(b);
    }
    b.innerHTML = '<span></span>';
    q(b, 'span').textContent = metin;
    if (bagAd) {
      var a = document.createElement('a');
      a.href = bagUrl; a.textContent = bagAd;
      b.appendChild(a);
    }
    requestAnimationFrame(function () { b.classList.add('acik'); });
    clearTimeout(bildirimZaman);
    bildirimZaman = setTimeout(function () { b.classList.remove('acik'); }, 4200);
  };

  /* ---------------- sepet ---------------- */
  FS.sepetOku = function () {
    return fetch(FS.sepetUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  };
  FS.sepeteEkle = function (govde) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(govde)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || FS.t('sepete_eklenemedi', 'Sepete eklenemedi.'));
        return j;
      });
    });
  };
  FS.sepetSayaci = function () {
    return FS.sepetOku().then(function (s) {
      qa(document, '[data-sepet-sayi]').forEach(function (e) {
        e.textContent = s.item_count;
        e.hidden = s.item_count === 0;
      });
      var bag = q(document, '[data-sepet-bag]');
      if (bag) bag.setAttribute('aria-label', FS.t('sepet_baglanti', 'Sepet, {{ adet }} ürün').replace('{{ adet }}', s.item_count));
      return s;
    });
  };

  /* ================= MODÜLLER ================= */
  var MODUL = {};

  /* ---------- üstbilgi ---------- */
  MODUL.ust = function (kok) {
    /* ---- kategori çekmecesi (V25) ----
       Bütün katmanlar sunucuda basıldı; burada yalnızca hangisinin görüneceğini
       seçiyoruz. `yol` dizisi gezinme yığını: son eleman görünen katmandır. */
    var cekAc = q(kok, '[data-cek-ac]'), cek = q(kok, '[data-cekmece]');
    if (cekAc && cek) {
      var katmanlar = qa(cek, '.cek-kat'),
          basAlan   = q(cek, '[data-cek-ad]'),
          geriBtn   = q(cek, '[data-cek-geri]'),
          kokAd     = basAlan ? basAlan.textContent : '',
          yol       = ['kok'],
          sonOdak   = null;

      function katBul(ad) {
        for (var i = 0; i < katmanlar.length; i++) {
          if (katmanlar[i].getAttribute('data-kat') === ad) return katmanlar[i];
        }
        return null;
      }
      var adlar = {};
      function goster() {
        var simdi = yol[yol.length - 1];
        katmanlar.forEach(function (k) { k.hidden = k.getAttribute('data-kat') !== simdi; });
        var k = katBul(simdi);
        if (basAlan) basAlan.textContent = (simdi === 'kok') ? kokAd : adlar[simdi] || (k && k.getAttribute('data-ad')) || kokAd;
        if (geriBtn) geriBtn.hidden = yol.length < 2;
        var g = q(cek, '.cek-govde');
        if (g) g.scrollTop = 0;
      }
      function ac() {
        sonOdak = document.activeElement;
        cek.hidden = false;
        // sınıf bir sonraki kareye bırakılır ki geçiş animasyonu çalışsın
        W.requestAnimationFrame(function () { cek.classList.add('acik'); });
        document.body.classList.add('cek-kilit');
        cekAc.setAttribute('aria-expanded', 'true');
        var ilk = q(cek, '.cek-kapat');
        if (ilk) ilk.focus();
      }
      function kapat() {
        cek.classList.remove('acik');
        document.body.classList.remove('cek-kilit');
        cekAc.setAttribute('aria-expanded', 'false');
        W.setTimeout(function () { cek.hidden = true; }, 220);
        if (sonOdak && sonOdak.focus) sonOdak.focus();
      }

      cekAc.addEventListener('click', function () {
        if (cek.hidden) {
          yol = ['kok'];
          var ag = q(cek, '[data-cek-ara]'); if (ag) ag.value = '';
          goster(); ac();
        } else { kapat(); }
      });
      qa(cek, '[data-cek-kapat]').forEach(function (b) {
        b.addEventListener('click', kapat);
      });
      if (geriBtn) geriBtn.addEventListener('click', function () {
        if (yol.length > 1) { yol.pop(); goster(); }
      });
      cek.addEventListener('click', function (ev) {
        var hedef = ev.target.closest ? ev.target.closest('[data-git]') : null;
        if (!hedef) return;
        ev.preventDefault();
        var git = hedef.getAttribute('data-git');
        if (hedef.getAttribute('data-git-ad')) adlar[git] = hedef.getAttribute('data-git-ad');
        if (yol[yol.length - 1] === 'ara') yol.pop();
        yol.push(git);
        goster();
      });

      /* Kategori araması (V26): the drawer's search box also finds categories.
         Typing shows matching rows from every layer; Enter still searches products. */
      var araGir = q(cek, '[data-cek-ara]'), araKat = katBul('ara'),
          araSonuc = q(cek, '[data-cek-ara-sonuc]'), araBos = q(cek, '[data-cek-ara-bos]');
      if (araGir && araKat && araSonuc) {
        var dizin = null;
        function kucuk(t) { return (t || '').toLocaleLowerCase('tr'); }
        function dizinKur() {
          dizin = []; var gor = {};
          qa(cek, '.cek-kat').forEach(function (kat) {
            var katAd = kat.getAttribute('data-kat') === 'kok' ? '' : (kat.getAttribute('data-ad') || '');
            if (kat.getAttribute('data-kat') === 'ara') return;
            qa(kat, '.cek-sat, .cek-cip').forEach(function (el) {
              if (el.classList.contains('cek-tumu')) return;
              var adEl = q(el, '.cek-sat-ad > span') || q(el, '.cek-sat-ad') || el;
              var ad = (adEl.firstChild && adEl.firstChild.nodeType === 3 ? adEl.firstChild.textContent : adEl.textContent).trim();
              if (!ad) return;
              var anahtar = ad + '|' + (el.getAttribute('href') || el.getAttribute('data-git'));
              if (gor[anahtar]) return; gor[anahtar] = 1;
              dizin.push({ ad: ad, ust: katAd, el: el });
            });
          });
        }
        araGir.addEventListener('input', function () {
          var s = kucuk(this.value.trim());
          if (!s) { if (yol[yol.length - 1] === 'ara') { yol.pop(); goster(); } return; }
          if (!dizin) dizinKur();
          var bulunan = dizin.filter(function (d) { return kucuk(d.ad).indexOf(s) !== -1; })
            .sort(function (a, b) { return kucuk(a.ad).indexOf(s) - kucuk(b.ad).indexOf(s); }).slice(0, 30);
          araSonuc.innerHTML = '';
          bulunan.forEach(function (d) {
            var k = d.el.cloneNode(true);
            k.classList.remove('cek-cip'); k.classList.add('cek-sat');
            var ip = q(k, '.cek-ipucu'); if (ip) ip.remove();
            if (d.ust) {
              var yolEl = document.createElement('small'); yolEl.className = 'cek-ipucu'; yolEl.textContent = d.ust;
              var adKutu = q(k, '.cek-sat-ad');
              if (adKutu) { adKutu.style.display = 'grid'; adKutu.appendChild(yolEl); }
            }
            araSonuc.appendChild(k);
          });
          if (araBos) araBos.hidden = bulunan.length > 0;
          if (yol[yol.length - 1] !== 'ara') yol.push('ara');
          goster();
        });
      }
      document.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Escape' || cek.hidden) return;
        if (yol.length > 1) { yol.pop(); goster(); } else { kapat(); }
      });

      /* 81 il katmanındaki plaka araması */
      var plaka = q(cek, '[data-cek-plaka]'), ilKap = q(cek, '[data-cek-iller]'),
          ilBos = q(cek, '[data-cek-il-bos]');
      if (plaka && ilKap) {
        var kutular = qa(ilKap, '.il');
        plaka.addEventListener('input', function () {
          var s = this.value.trim().toLocaleLowerCase('tr'), n = 0;
          kutular.forEach(function (el) {
            var metin = (el.textContent || '').toLocaleLowerCase('tr');
            var uyar = !s || metin.indexOf(s) !== -1;
            el.hidden = !uyar;
            if (uyar) n++;
          });
          if (ilBos) ilBos.hidden = !(s && n === 0);
        });
      }

      goster();
    }

    var girdi = q(kok, '[data-ara-girdi]'), kutu = q(kok, '[data-ara-sonuc]');
    if (girdi && kutu) {
      var zaman, sonSorgu = '';
      function kapat() { kutu.hidden = true; kutu.innerHTML = ''; }
      girdi.addEventListener('input', function () {
        var s = this.value.trim();
        clearTimeout(zaman);
        if (s.length < 2) { kapat(); return; }
        zaman = setTimeout(function () {
          if (s === sonSorgu) return;
          sonSorgu = s;
          var u = FS.araUrl + '/suggest.json?q=' + encodeURIComponent(s)
            + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          fetch(u, { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              var liste = (j.resources && j.resources.results && j.resources.results.products) || [];
              // Baskı ücreti ürünü aramada çıkmaz.
              if (FS.baskiHandle) {
                liste = liste.filter(function (p) { return p.handle !== FS.baskiHandle; });
              }
              if (!liste.length) {
                kutu.innerHTML = '<p>“' + s + '” ' + FS.t('sonuc_yok', 'için sonuç yok.') + ' <a href="' + FS.araUrl
                  + '?q=' + encodeURIComponent(s) + '">' + FS.t('tum_katalog', 'Tüm katalogda ara') + '</a></p>';
              } else {
                kutu.innerHTML = liste.map(function (p) {
                  var g = p.featured_image && p.featured_image.url
                    ? '<img src="' + p.featured_image.url + '&width=110" alt="" loading="lazy">'
                    : '<span style="width:44px;height:58px;background:var(--koyu);flex-shrink:0"></span>';
                  return '<a href="' + p.url + '">' + g + '<span><b>' + p.title
                    + '</b><em>' + (p.price ? FS.para(p.price) : '') + '</em></span></a>';
                }).join('') + '<p><a href="' + FS.araUrl + '?q=' + encodeURIComponent(s)
                  + '">“' + s + '” ' + FS.t('tum_sonuclar', 'için tüm sonuçlar →') + '</a></p>';
              }
              kutu.hidden = false;
            })
            .catch(kapat);
        }, 220);
      });
      girdi.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') kapat(); });
      document.addEventListener('click', function (ev) {
        if (!kutu.contains(ev.target) && ev.target !== girdi) kapat();
      });
    }

    FS.sepetSayaci();
  };

  /* ---------- ana sayfa: tezgâh animasyonu ---------- */
  MODUL.tezgah = function (kok) {
    var v = veri(kok);
    var sahne = q(kok, '[data-sahne]');
    if (!sahne || !v.sahneler || !v.sahneler.length) return;

    var alan = q(kok, '[data-alan]'), yazi = q(kok, '[data-yazi]'), imlec = q(kok, '[data-imlec]'),
        baski = q(kok, '[data-baski]'), fiyatEl = q(kok, '[data-fiyat]'),
        fare = q(kok, '[data-fare]'), halka = q(kok, '[data-halka]');
    var URUN = v.urunler, SAHNE = v.sahneler, HEDEF = v.hedef;
    var d = { i: 0, faz: 'goUrun', yazi: '', uU: 0, uR: 0, uT: 0 }, zaman;

    function bezGoster() {
      qa(sahne, '.bez').forEach(function (im) {
        im.classList.toggle('on', im.getAttribute('data-bez') === d.uU + '-' + d.uR);
      });
    }
    function cipGoster() {
      qa(sahne, '[data-u]').forEach(function (c) { c.classList.toggle('on', +c.getAttribute('data-u') === d.uU); });
      qa(sahne, '[data-t]').forEach(function (c) { c.classList.toggle('on-k', +c.getAttribute('data-t') === d.uT); });
      if (fiyatEl) fiyatEl.textContent = FS.para(URUN[d.uU].fiyat);
    }
    function alanGoster() {
      var sc = SAHNE[d.i % SAHNE.length];
      alan.style.top = URUN[d.uU].ustKaro + '%';
      alan.style.width = (d.uT === 0 ? '22%' : '27%');
      var gorselMi = d.uT === 0;
      baski.hidden = !gorselMi;
      yazi.hidden = gorselMi; imlec.hidden = gorselMi;
      if (gorselMi && sc.baski) baski.src = sc.baski[d.uR];
      if (!gorselMi) {
        var n = (d.yazi || 'XXXXXXXX').length;
        var boy = n <= 9 ? 24 : (n <= 12 ? 20.5 : 17.5);
        yazi.textContent = d.yazi;
        yazi.style.fontSize = boy + 'px';
        yazi.style.color = (d.uR === 0 ? '#F7F5F0' : '#16130F');
        imlec.style.height = (boy * 0.88) + 'px';
      }
    }
    function fareyeGit(p) {
      fare.style.left = p[0] + '%'; fare.style.top = p[1] + '%';
      halka.style.left = p[0] + '%'; halka.style.top = p[1] + '%';
    }
    function halkaAc(a) { halka.style.opacity = a ? '1' : '0'; halka.style.transform = a ? 'scale(1)' : 'scale(.4)'; }

    function adim() {
      var sc = SAHNE[d.i % SAHNE.length], bekle = 500;
      switch (d.faz) {
        case 'goUrun': fareyeGit(HEDEF.urun[sc.u]); halkaAc(false); d.faz = 'basUrun'; bekle = 700; break;
        case 'basUrun': halkaAc(true); d.uU = sc.u; d.uR = sc.r; bezGoster(); cipGoster(); alanGoster(); d.faz = 'goTip'; bekle = 300; break;
        case 'goTip': halkaAc(false); fareyeGit(HEDEF.tip[sc.t]); d.faz = 'basTip'; bekle = 560; break;
        case 'basTip': halkaAc(true); d.uT = sc.t; cipGoster(); alanGoster(); d.faz = 'goGogus'; bekle = 300; break;
        case 'goGogus': halkaAc(false); fareyeGit(HEDEF.gogus); d.faz = (sc.t === 0 ? 'bas' : 'yaz'); bekle = 540; break;
        case 'bas': baski.style.opacity = '1'; baski.style.transform = 'scale(1)'; d.faz = 'dur'; bekle = 2500; break;
        case 'yaz':
          if (d.yazi.length < sc.metin.length) {
            d.yazi = sc.metin.slice(0, d.yazi.length + 1); alanGoster();
            bekle = (sc.metin.charAt(d.yazi.length - 1) === ' ') ? 200 : 92;
          } else { d.faz = 'dur'; bekle = 1900; }
          break;
        case 'dur':
          if (sc.t === 0) { baski.style.opacity = '0'; baski.style.transform = 'scale(1.16)'; d.faz = 'sonraki'; bekle = 480; }
          else { d.faz = 'sil'; bekle = 50; }
          break;
        case 'sil':
          if (d.yazi.length > 0) { d.yazi = sc.metin.slice(0, d.yazi.length - 1); alanGoster(); bekle = 38; }
          else { d.faz = 'sonraki'; bekle = 260; }
          break;
        case 'sonraki': d.i++; d.yazi = ''; d.faz = 'goUrun'; bekle = 320; break;
      }
      zaman = setTimeout(adim, bekle);
    }

    bezGoster(); cipGoster(); alanGoster();
    if (FS.azalt) {
      fare.style.display = 'none';
      baski.style.opacity = '1'; baski.style.transform = 'scale(1)';
    } else {
      baski.style.opacity = '0'; baski.style.transform = 'scale(1.16)';
      var gor = new IntersectionObserver(function (g) {
        if (g[0].isIntersecting) { if (!zaman) zaman = setTimeout(adim, 900); }
        else { clearTimeout(zaman); zaman = null; }
      }, { threshold: 0.15 });
      gor.observe(sahne);
    }
  };

  /* ---------- ürün ---------- */
  MODUL.urun = function (kok) {
    var v = veri(kok);
    var s = {};
    Object.keys(v.baslangic || {}).forEach(function (k) { s[k] = v.baslangic[k]; });
    // Başlangıç seçimi boş gelirse (renk/beden null) stoktaki ilk varyantı seç — yoksa tüm bedenler 'tükendi' görünüyordu.
    (function () {
      var vs = v.varyantlar || [], bos = !Object.keys(s).length;
      Object.keys(s).forEach(function (k) { if (s[k] == null) bos = true; });
      if (!bos) return;
      var ilk = null;
      for (var i0 = 0; i0 < vs.length; i0++) { if (vs[i0].stokta) { ilk = vs[i0]; break; } }
      ilk = ilk || vs[0];
      if (ilk) Object.keys(ilk.secim).forEach(function (k) { if (s[k] == null) s[k] = ilk.secim[k]; });
    })();
    // Varsayılan beden M (linkte ?variant= yoksa ve M stoktaysa) — yanlışlıkla XS sipariş edilmesin.
    (function () {
      if (!v.bedenAdi || /[?&]variant=/.test(location.search)) return;
      var vs = v.varyantlar || [];
      for (var i1 = 0; i1 < vs.length; i1++) {
        var x1 = vs[i1], uy = x1.stokta && x1.secim[v.bedenAdi] === 'M';
        for (var k1 in x1.secim) { if (k1 !== v.bedenAdi && s[k1] != null && x1.secim[k1] !== s[k1]) uy = false; }
        if (uy) { s[v.bedenAdi] = 'M'; break; }
      }
    })();

    var buyuk = q(kok, '[data-buyuk]'),
        fiyatEl = q(kok, '[data-urun-fiyat]'),
        notEl = q(kok, '[data-urun-not]'),
        ekleBtn = q(kok, '[data-ekle]'),
        barFiyat = q(kok, '[data-bar-fiyat]'),
        barOzet = q(kok, '[data-bar-ozet]'),
        barEkle = q(kok, '[data-bar-ekle]'),
        idAlan = q(kok, '[data-varyant-id]'),
        yerAlan = q(kok, '[data-yer-alan]'),
        kargoEl = q(kok, '[data-kargo-not]');

    // Baskı yeri fiyatı değiştirmez; siparişe satır notu olarak gider.
    var yer = 'on';
    function yerAdi() {
      var b = q(kok, '[data-yer="' + yer + '"]');
      return b ? b.getAttribute('data-ad') : '';
    }

    // Verilen seçimle eşleşen varyantı bulur. `ustunden` ile tek bir seçenek geçici
    // olarak değiştirilebilir — beden düğmelerinin fiyatı böyle hesaplanıyor.
    function bul(ustAd, ustDeger) {
      for (var i = 0; i < v.varyantlar.length; i++) {
        var x = v.varyantlar[i], uyar = true;
        for (var ad in x.secim) {
          var istenen = (ad === ustAd) ? ustDeger : s[ad];
          if (istenen !== undefined && x.secim[ad] !== istenen) { uyar = false; break; }
        }
        if (uyar) return x;
      }
      return null;
    }

    function ozet() {
      var p = [];
      if (v.giysi) p.push(v.giysi);
      Object.keys(s).forEach(function (ad) { p.push(s[ad]); });
      if (yer !== 'on') p.push(yerAdi());
      return p.join(' · ');
    }

    function ciz() {
      // seçilen beden tükendiyse stokta olan ilk bedene kay
      if (v.bedenAdi) {
        var suan = bul();
        if (!suan || !suan.stokta) {
          var btnler = qa(kok, '[data-bd]');
          for (var i = 0; i < btnler.length; i++) {
            var bd = btnler[i].getAttribute('data-bd'), y = bul(v.bedenAdi, bd);
            if (y && y.stokta) { s[v.bedenAdi] = bd; break; }
          }
        }
      }

      var x = bul();

      if (x && x.gorsel) {
        buyuk.src = x.gorsel;
        if (x.gorselAlt) buyuk.alt = x.gorselAlt;
      }
      qa(kok, '[data-kucuk]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-kucuk') === String(x && x.gorselId || '')));
      });

      // beden düğmeleri — her birinin kendi fiyatı ve kendi stok durumu
      qa(kok, '[data-bd]').forEach(function (b) {
        var bd = b.getAttribute('data-bd'), y = bul(v.bedenAdi, bd);
        var yok = !(y && y.stokta);
        b.disabled = yok;
        b.setAttribute('aria-pressed', String(bd === s[v.bedenAdi]));
        var e = q(b, 'em');
        if (e) e.textContent = yok ? FS.t('tukendi_kucuk', 'tükendi') : FS.para(y.fiyat);
      });

      // diğer seçenekler
      qa(kok, '[data-sec]').forEach(function (b) {
        var ad = b.getAttribute('data-sec'), d = b.getAttribute('data-deg');
        b.setAttribute('aria-pressed', String(s[ad] === d));
        var y = bul(ad, d);
        b.classList.toggle('yok-secenek', !(y && y.stokta));
      });
      qa(kok, '[data-sec-ad]').forEach(function (e) {
        // Görünen ad düğmenin data-ad'inden gelir (dile çevrilmiş hâli);
        // eşleşme hâlâ Türkçe data-deg değeriyle yapılır.
        var secAdi = e.getAttribute('data-sec-ad');
        var deger = s[secAdi] || '';
        var yazi = deger;
        qa(kok, '[data-sec]').forEach(function (b) {
          if (b.getAttribute('data-sec') === secAdi && b.getAttribute('data-deg') === deger) {
            yazi = b.getAttribute('data-ad') || deger;
          }
        });
        e.textContent = yazi;
      });

      // baskı yeri
      qa(kok, '[data-yer]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-yer') === yer));
      });
      if (yerAlan) yerAlan.value = yerAdi();

      if (!x) {
        ekleBtn.disabled = true;
        ekleBtn.textContent = FS.t('birlesim_yok', 'Bu birleşim yok');
        ekleBtn.style.background = '#8A857D';
        return;
      }

      fiyatEl.textContent = FS.para(x.fiyat);
      if (notEl) {
        var bd2 = v.bedenAdi ? s[v.bedenAdi] : '';
        notEl.textContent = (x.fiyat > v.enDusukFiyat)
          ? bd2 + ' ' + FS.t('beden_farki', 'beden · büyük beden farkı +') + FS.para(x.fiyat - v.enDusukFiyat)
          : FS.t('kdv_dahil', 'KDV dahil') + (bd2 ? ' · ' + bd2 : '');
      }
      if (kargoEl) {
        if (FS.kargoEsik > 0 && x.fiyat >= FS.kargoEsik) {
          kargoEl.innerHTML = '<b style="font-weight:600;color:var(--yesil)">' + FS.t('kargo_bedava_urun', 'Bu üründe kargo bedava') + '</b>'
            + '<small>' + FS.para(FS.kargoEsik) + ' ' + FS.t('kargo_bedava_uzeri', 'üzeri tüm siparişlerde.') + '</small>';
        } else if (FS.kargoEsik > 0) {
          kargoEl.innerHTML = '<b style="font-weight:600">' + FS.t('kargo', 'Kargo') + ' ' + FS.para(FS.kargoUcret) + '</b>'
            + '<small>' + FS.para(FS.kargoEsik - x.fiyat) + ' ' + FS.t('kargo_kalan', 'daha eklersen kargo bedava.') + '</small>';
        } else {
          kargoEl.innerHTML = '<b style="font-weight:600">' + FS.t('kargo', 'Kargo') + ' ' + FS.para(FS.kargoUcret) + '</b>'
            + '<small>' + FS.t('baski_suresi', 'Baskı 1–3 iş günü, sonra kargoya verilir.') + '</small>';
        }
      }

      idAlan.value = x.id;
      ekleBtn.disabled = !x.stokta;
      ekleBtn.textContent = x.stokta ? FS.t('sepete_ekle', 'Sepete ekle') + ' — ' + FS.para(x.fiyat) : FS.t('tukendi', 'Tükendi');
      ekleBtn.style.background = x.stokta ? 'var(--kirmizi)' : '#8A857D';
      if (barFiyat) barFiyat.textContent = FS.para(x.fiyat);
      if (barOzet) barOzet.textContent = ozet();
      if (barEkle) {
        barEkle.disabled = !x.stokta;
        barEkle.textContent = x.stokta ? FS.t('sepete_ekle', 'Sepete ekle') : FS.t('tukendi', 'Tükendi');
        barEkle.style.background = x.stokta ? 'var(--kirmizi)' : '#8A857D';
      }
      if (W.history && history.replaceState) {
        history.replaceState({}, '', v.url + '?variant=' + x.id);
      }
    }

    kok.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-bd],[data-sec],[data-kucuk],[data-yer]');
      if (!b || b.disabled) return;
      ev.preventDefault();
      if (b.hasAttribute('data-yer')) {
        yer = b.getAttribute('data-yer');
      } else if (b.hasAttribute('data-bd')) {
        s[v.bedenAdi] = b.getAttribute('data-bd');
      } else if (b.hasAttribute('data-sec')) {
        s[b.getAttribute('data-sec')] = b.getAttribute('data-deg');
      } else {
        var gid = b.getAttribute('data-kucuk');
        var y = v.varyantlar.filter(function (x) { return String(x.gorselId) === gid; })[0];
        if (y) { Object.keys(y.secim).forEach(function (ad) {
          if (ad !== v.bedenAdi) s[ad] = y.secim[ad];
        }); }
      }
      ciz();
    });

    var form = q(kok, '.fs-urun-form');
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = ev.submitter || ekleBtn;
      var eski = btn.textContent;
      btn.disabled = true; btn.textContent = FS.t('ekleniyor', 'Ekleniyor…');
      var satir = { id: +idAlan.value, quantity: 1 };
      if (yerAlan) satir.properties = { 'Baskı yeri': yerAdi() };
      FS.sepeteEkle({ items: [satir] })
        .then(function () {
          btn.textContent = FS.t('sepete_eklendi', 'Sepete eklendi ✓');
          btn.style.background = 'var(--yesil)';
          FS.sepetSayaci();
          FS.bildir(FS.t('sepete_eklendi_kisa', 'Sepete eklendi.'), FS.t('sepete_git', 'Sepete git'), FS.sepetUrl);
          setTimeout(function () { ciz(); }, 2200);
        })
        .catch(function (e) {
          btn.disabled = false; btn.textContent = eski;
          FS.bildir(e.message || FS.t('sepete_eklenemedi', 'Sepete eklenemedi.'));
        });
    });

    ciz();
  };

  /* ---------- kendin tasarla ---------- */
  MODUL.tasarla = function (kok) {
    var v = veri(kok);
    var T = { tip: 0, yazi: v.ornekYazi || '', urun: 0, renk: 0, beden: v.baslangicBeden || 'M', dosya: null, yer: 'on' };

    // Baskı yeri metinleri — siparişe de bu yazılır.
    var YER = {
      on:   { ad: FS.t('yer_on', 'Ön (göğüs)'),  fis: FS.t('baski_on', 'Baskı — ön göğüs'), not: FS.t('on_aciklama', 'Tasarım göğse basılır.') },
      arka: { ad: FS.t('yer_arka', 'Arka (sırt)'), fis: FS.t('baski_arka', 'Baskı — arka sırt'), not: FS.t('arka_aciklama', 'Önizleme ön yüzü gösteriyor; baskı sırta yapılacak.') },
      iki:  { ad: FS.t('yer_iki', 'Ön + arka'),   fis: FS.t('baski_on', 'Baskı — ön göğüs'),  not: FS.t('iki_aciklama', 'Aynı tasarım hem göğse hem sırta basılır — iki ayrı baskı, iki ayrı ücret.') }
    };

    var tuval = q(kok, '[data-tuval]'), alan = q(kok, '[data-alan]'),
        yaziEl = q(kok, '[data-yazi]'), imlec = q(kok, '[data-imlec]'),
        baski = q(kok, '[data-baski]'), olcu = q(kok, '[data-olcu]'), olcuEt = q(kok, '[data-olcu-et]'),
        girdi = q(kok, '[data-girdi]'), dosyaGirdi = q(kok, '[data-dosya]');
    var EN = v.enCok || 24;

    function varyant() {
      var giysi = v.urunler[T.urun].ad;
      var renk = T.renk === 0 ? 'Siyah' : 'Beyaz';
      for (var i = 0; i < v.varyantlar.length; i++) {
        var x = v.varyantlar[i];
        if (v.giysiVar && x.giysi !== giysi) continue;
        if (v.renkVar && x.renk !== renk) continue;
        if (x.beden && x.beden !== T.beden) continue;
        return x;
      }
      return null;
    }
    function tasarMi() { return T.tip === 0 && (T.yazi || '').length > EN; }

    function grup(sec, oku) {
      var kap = q(kok, sec);
      if (!kap) return;
      kap.addEventListener('click', function (ev) {
        var b = ev.target.closest('button'); if (!b) return;
        ev.preventDefault();
        qa(kap, 'button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        oku(b.getAttribute('data-v'));
        ciz();
      });
    }
    grup('[data-g-tip]', function (x) { T.tip = +x; });
    grup('[data-g-urun]', function (x) { T.urun = +x; });
    grup('[data-g-renk]', function (x) { T.renk = +x; });
    grup('[data-g-beden]', function (x) { T.beden = x; });
    grup('[data-g-yer]', function (x) { T.yer = x; });

    if (girdi) girdi.addEventListener('input', function () { T.yazi = this.value; ciz(); });

    if (dosyaGirdi) {
      dosyaGirdi.addEventListener('change', function () {
        var f = this.files && this.files[0];
        T.dosya = f || null;
        var ad = q(kok, '[data-dosya-ad]'), not = q(kok, '[data-dosya-not]');
        if (!f) {
          ad.textContent = FS.t('gorsel_sec', 'Görselini seç');
          not.textContent = FS.t('gorsel_not', 'PNG ya da JPG · en az 1000 px genişlik');
          ciz();
          return;
        }
        ad.textContent = f.name;
        not.textContent = (f.size / 1048576).toFixed(1).replace('.', ',') + ' MB · ' + FS.t('okunuyor', 'okunuyor…');
        var okuyucu = new FileReader();
        okuyucu.onload = function (e) {
          baski.src = e.target.result;
          var im = new Image();
          im.onload = function () {
            var yeterli = im.naturalWidth >= 1000;
            not.textContent = (f.size / 1048576).toFixed(1).replace('.', ',') + ' MB · '
              + im.naturalWidth + ' × ' + im.naturalHeight + ' px · '
              + (yeterli ? FS.t('cozunurluk_iyi', 'yeterli çözünürlük ✓') : FS.t('cozunurluk_dusuk', 'düşük çözünürlük — baskıda bulanık çıkabilir'));
            not.style.color = yeterli ? 'var(--ikincil)' : 'var(--kirmizi)';
          };
          im.src = e.target.result;
        };
        okuyucu.readAsDataURL(f);
        ciz();
      });
    }

    function ciz() {
      var u = v.urunler[T.urun], siyah = T.renk === 0, gorselMi = T.tip === 1;

      qa(tuval, '.bez').forEach(function (im) {
        im.classList.toggle('on', im.getAttribute('data-bez') === T.urun + '-' + T.renk);
      });
      q(kok, '[data-yazi-alani]').hidden = gorselMi;
      q(kok, '[data-gorsel-alani]').hidden = !gorselMi;
      baski.hidden = !gorselMi;
      yaziEl.hidden = gorselMi; imlec.hidden = gorselMi;
      if (gorselMi && !T.dosya && v.ornekBaski) baski.src = v.ornekBaski[T.renk];

      alan.style.top = u.ustTam + '%';
      alan.style.width = gorselMi ? '24%' : '28%';

      var metin = T.yazi || 'BURAYA YAZ', n = metin.length;
      var boy = n <= 9 ? 40 : (n <= 14 ? 32 : (n <= 19 ? 26 : 21));
      yaziEl.textContent = metin;
      yaziEl.style.fontSize = boy + 'px';
      yaziEl.style.color = siyah ? '#F7F5F0' : '#16130F';
      yaziEl.style.opacity = T.yazi ? '1' : '.45';
      imlec.style.height = (boy * 0.88) + 'px';

      var yakaY = u.yaka / 1446 * 100, cm = (FS.yakaCm * 13.5) / 1446 * 100;
      olcu.style.top = yakaY + '%'; olcu.style.height = cm + '%';
      olcuEt.style.top = (yakaY + cm / 2 - 1.2) + '%';

      var x = varyant();
      // Varyant fiyatı bir baskı dahil satılıyor; fişte ikiye ayırıyoruz.
      // "İkisi de" seçilirse ikinci baskı ayrı bir satır ürünü olarak eklenir.
      var yy = YER[T.yer] || YER.on;
      var ikiMi = T.yer === 'iki' && !!v.baskiVaryant;
      var kacBaski = ikiMi ? 2 : 1;
      var urunFiyat = x ? x.fiyat : 0;
      // Baskı ürünü seçiliyse varyant fiyatı baskısız giysi fiyatıdır; değilse
      // baskı ücreti varyantın içindedir ve fişte ondan ayrıştırılır.
      var taban = v.ayriBaski ? urunFiyat : Math.max(0, urunFiyat - v.baskiUcret);
      var toplam = taban + v.baskiUcret * kacBaski;
      var bedava = FS.kargoEsik > 0 && toplam >= FS.kargoEsik;

      qa(kok, '[data-g-yer] button').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === T.yer));
      });
      var ynot = q(kok, '[data-yer-not]');
      if (ynot) ynot.textContent = yy.not;
      var bet = q(kok, '[data-baski-et]');
      if (bet) bet.textContent = yy.fis;
      var bt = q(kok, '[data-baski-tutar]');
      if (bt) bt.textContent = FS.para(v.baskiUcret);
      var at = q(kok, '[data-arka-tutar]');
      if (at) at.textContent = FS.para(v.baskiUcret);
      var asat = q(kok, '[data-arka-satir]');
      if (asat) asat.hidden = !ikiMi;

      q(kok, '[data-ozet]').textContent = (u.etiket || u.ad) + ' · ' + (siyah ? FS.t('siyah', 'Siyah') : FS.t('beyaz', 'Beyaz')) + ' · ' + T.beden;
      q(kok, '[data-taban]').textContent = FS.para(taban);
      var kg = q(kok, '[data-kargo]');
      kg.textContent = bedava ? FS.t('ucretsiz', 'Ücretsiz') : FS.para(FS.kargoUcret);
      kg.style.color = bedava ? 'var(--yesil)' : '';
      kg.style.fontWeight = bedava ? '600' : '';
      q(kok, '[data-toplam]').textContent = FS.para(bedava ? toplam : toplam + FS.kargoUcret);

      var kalanEl = q(kok, '[data-kalan]');
      if (kalanEl) kalanEl.textContent = (EN - (T.yazi || '').length) + ' ' + FS.t('karakter_kaldi', 'karakter kaldı');
      var sg = q(kok, '[data-sigar]');
      if (sg) {
        sg.textContent = tasarMi() ? FS.t('sigmiyor', 'Kadraja sığmıyor') : FS.t('siginiyor', 'Kadraja sığıyor');
        sg.style.color = tasarMi() ? 'var(--kirmizi)' : 'var(--yesil)';
      }

      var uy = q(kok, '[data-uyari]'), sorun = '';
      if (tasarMi()) sorun = FS.t('kisalt', 'Yazı baskı kadrajına sığmıyor — biraz kısalt.');
      else if (T.tip === 0 && !(T.yazi || '').trim()) sorun = FS.t('yazi_yaz', 'Basacağımız yazıyı yaz.');
      else if (T.tip === 1 && !T.dosya) sorun = FS.t('gorsel_yukle', 'Basacağımız görseli yükle.');
      else if (!x) sorun = FS.t('birlesim_yok_uzun', 'Bu birleşim şu anda yok.');
      else if (!x.stokta) sorun = FS.t('beden_tukendi', 'Bu beden tükendi.');
      uy.hidden = sorun === '';
      uy.textContent = sorun;

      var btn = q(kok, '[data-ekle]');
      btn.disabled = sorun !== '';
      btn.style.background = sorun !== '' ? '#8A857D' : 'var(--kirmizi)';
      btn.textContent = sorun === '' ? 'Sepete ekle — ' + FS.para(toplam) : 'Sepete ekle';
      q(kok, '[data-varyant-id]').value = x ? x.id : '';
    }

    q(kok, '.fs-tasarla-form').addEventListener('submit', function (ev) {
      ev.preventDefault();
      var x = varyant();
      var btn = q(kok, '[data-ekle]');
      if (!x || btn.disabled) return;
      var eski = btn.textContent;
      btn.disabled = true; btn.textContent = FS.t('ekleniyor', 'Ekleniyor…');

      var ikiMi = T.yer === 'iki' && !!v.baskiVaryant;
      var yerMetin = (YER[T.yer] || YER.on).ad + ', yakadan ' + FS.yakaCm + ' cm';
      // Ayrı baskı satırı: ön için 1, ön+arka için 2 adet.
      var baskiAdet = v.ayriBaski ? (ikiMi ? 2 : 1) : (ikiMi ? 1 : 0);

      // Görsel varsa multipart gerekir; /cart/add.js FormData'yı kabul eder.
      var istek;
      if (T.tip === 1 && T.dosya) {
        var fd = new FormData();
        fd.append('id', x.id);
        fd.append('quantity', 1);
        fd.append('properties[Görsel]', T.dosya, T.dosya.name);
        fd.append('properties[Baskı yeri]', yerMetin);
        istek = fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json().then(function (j) {
              if (!r.ok) throw new Error(j.description || j.message || FS.t('sepete_eklenemedi', 'Sepete eklenemedi.'));
              return j;
            });
          });
      } else {
        var oz = { 'Baskı yeri': yerMetin };
        oz['Yazı'] = T.yazi;
        istek = FS.sepeteEkle({ items: [{ id: x.id, quantity: 1, properties: oz }] });
      }

      // Baskı ücreti ayrı satır olarak eklenir.
      if (baskiAdet > 0 && v.baskiVaryant) {
        istek = istek.then(function () {
          return FS.sepeteEkle({
            items: [{
              id: v.baskiVaryant,
              quantity: baskiAdet,
              properties: { 'Baskı yeri': (YER[T.yer] || YER.on).ad }
            }]
          });
        });
      }

      istek.then(function () {
        btn.textContent = FS.t('sepete_eklendi', 'Sepete eklendi ✓');
        btn.style.background = 'var(--yesil)';
        FS.sepetSayaci();
        FS.bildir(FS.t('tasarim_eklendi', 'Tasarımın sepete eklendi.'), FS.t('sepete_git', 'Sepete git'), FS.sepetUrl);
        setTimeout(ciz, 2400);
      }).catch(function (e) {
        btn.disabled = false; btn.textContent = eski;
        FS.bildir(e.message || FS.t('sepete_eklenemedi', 'Sepete eklenemedi.'));
      });
    });

    ciz();
  };

  /* ---------- sepet ---------- */
  MODUL.sepet = function (kok) {
    function guncelle(satir, adet) {
      kok.classList.add('yukleniyor');
      fetch(FS.sepetUrl + '/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: satir, quantity: adet })
      }).then(function (r) { return r.json(); })
        .then(function () { W.location.reload(); })
        .catch(function () { kok.classList.remove('yukleniyor'); FS.bildir(FS.t('sepet_hatasi', 'Sepet güncellenemedi.')); });
    }

    kok.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-az],[data-cok],[data-sil]');
      if (!b || b.disabled) return;
      ev.preventDefault();
      var satir = +b.getAttribute('data-satir');
      var simdi = +b.getAttribute('data-adet');
      if (b.hasAttribute('data-cok')) guncelle(satir, simdi + 1);
      else if (b.hasAttribute('data-az')) guncelle(satir, Math.max(0, simdi - 1));
      else guncelle(satir, 0);
    });
  };

  /* ---------- şehirler (81 plaka) ---------- */
  MODUL.sehirler = function (kok) {
    var girdi = q(kok, '[data-sehir-ara]');
    if (!girdi) return;
    var sayac = q(kok, '[data-sehir-sayi]');
    function nrm(x) {
      return (x || '').toLocaleLowerCase('tr')
        .replace(/[âÂ]/g, 'a').replace(/[îÎ]/g, 'i').replace(/[ûÛ]/g, 'u').trim();
    }
    girdi.addEventListener('input', function () {
      var s = nrm(this.value), n = 0;
      qa(kok, '[data-il]').forEach(function (e) {
        var plaka = e.getAttribute('data-plaka') || '';
        /* ad: içinde geçsin yeter (Şanlıurfa <- "urfa"); plaka: baştan eşleşsin */
        var uy = !s || nrm(e.getAttribute('data-il')).indexOf(s) >= 0
          || (plaka !== '' && plaka.indexOf(s) === 0);
        e.hidden = !uy;
        if (uy) n++;
      });
      if (sayac) sayac.textContent = n;
    });
  };

  /* Koleksiyon rayı: üstteki tek kutu her bölmede arar, eşleşen bölme açılır;
     şehir bölmesinin ayrıca kendi plaka kutusu var. */
  MODUL.ray = function (kok) {
    var genel = q(kok, '[data-ray-ara]');
    var bos = q(kok, '[data-ray-bos]');
    var gruplar = qa(kok, '.ray-grup');
    if (!gruplar.length) return;

    function nrm(x) {
      return (x || '').toLocaleLowerCase('tr')
        .replace(/[âÂ]/g, 'a').replace(/[îÎ]/g, 'i').replace(/[ûÛ]/g, 'u').trim();
    }
    function uyar(satir, s) {
      if (!s) return true;
      var plaka = satir.getAttribute('data-plaka') || '';
      if (plaka !== '' && plaka.indexOf(s) === 0) return true;
      return nrm(satir.getAttribute('data-ara')).indexOf(s) >= 0;
    }
    function say(grup) { return qa(grup, '[data-ray-oge]').length; }

    gruplar.forEach(function (g) { g.dataset.rayToplam = say(g); });

    if (genel) {
      genel.addEventListener('input', function () {
        var s = nrm(this.value), toplam = 0;
        gruplar.forEach(function (g) {
          var n = 0;
          qa(g, '[data-ray-oge]').forEach(function (e) {
            var uy = uyar(e, s);
            e.hidden = !uy;
            if (uy) n++;
          });
          g.hidden = !!s && n === 0;
          g.open = !!s && n > 0;
          var sayac = q(g, '[data-ray-say]');
          if (sayac) sayac.textContent = s ? n : g.dataset.rayToplam;
          toplam += n;
        });
        if (bos) bos.hidden = !(s && toplam === 0);
      });
    }

    var plakaGirdi = q(kok, '[data-plaka-ara]');
    if (plakaGirdi) {
      var ipucu = q(kok, '[data-plaka-ipucu]');
      var ipucuAsil = ipucu ? ipucu.textContent : '';
      var sehirGrup = plakaGirdi.closest ? plakaGirdi.closest('.ray-grup') : null;
      plakaGirdi.addEventListener('click', function (e) { e.stopPropagation(); });
      plakaGirdi.addEventListener('input', function () {
        if (!sehirGrup) return;
        var s = nrm(this.value), n = 0;
        qa(sehirGrup, '[data-ray-oge]').forEach(function (e) {
          var uy = uyar(e, s);
          e.hidden = !uy;
          if (uy) n++;
        });
        var sayac = q(sehirGrup, '[data-ray-say]');
        if (sayac) sayac.textContent = s ? n : sehirGrup.dataset.rayToplam;
        if (ipucu) ipucu.textContent = (s && n === 0) ? FS.t('plaka_yok', 'Böyle bir plaka ya da şehir yok.') : ipucuAsil;
      });
    }
  };


  /* ---------- dönem şeridi + tek seferlik bildirim (V26) ----------
     Days are counted in Istanbul time so a cached page still shows the right number.
     After the end date the whole block hides itself even if the HTML was cached. */
  MODUL.donem = function (kok) {
    var veri = {};
    try { veri = JSON.parse((q(kok, '[data-fs-veri]') || {}).textContent || '{}'); } catch (e) {}
    function gunNo(s) { // 'YYYY-MM-DD' -> ms of that day 00:00 in Istanbul (UTC+3)
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((s || '').trim());
      return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) - 3 * 36e5 : null;
    }
    var simdi = Date.now();
    var bitis = gunNo(kok.dataset.bitis);
    if (bitis !== null && simdi >= bitis) { kok.hidden = true; return; }

    var son = gunNo(kok.dataset.son);
    var sonEl = q(kok, '[data-donem-son]');
    if (sonEl && son !== null && simdi >= son + 864e5) sonEl.hidden = true;

    var hedef = gunNo(kok.dataset.hedef);
    var gunEl = q(kok, '[data-donem-gun]');
    if (gunEl && hedef !== null) {
      var kalan = Math.ceil((hedef - simdi) / 864e5);
      if (kalan > 0) {
        gunEl.textContent = (veri.gun || '# gün').replace('#', kalan);
        gunEl.hidden = false;
      }
    }

    var b = q(kok, '[data-donem-bildirim]');
    if (!b) return;
    var sablon = kok.dataset.sablon || '';
    if (/^(product|cart)/.test(sablon)) return;
    var anahtar = kok.dataset.anahtar || 'fs-donem';
    var goruldu = false;
    try { goruldu = W.localStorage.getItem(anahtar) === '1'; } catch (e) { return; }
    if (goruldu) return;
    function kapat() { b.hidden = true; }
    W.setTimeout(function () {
      b.hidden = false;
      try { W.localStorage.setItem(anahtar, '1'); } catch (e) {}
    }, 2500);
    var x = q(b, '[data-donem-kapat]');
    if (x) x.addEventListener('click', kapat);
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') kapat(); });
  };

  /* ---------- açılış ---------- */
  function baslat(kap) {
    qa(kap, '[data-fs]').forEach(function (kok) {
      if (kok.dataset.fsKuruldu) return;
      var ad = kok.getAttribute('data-fs');
      if (!MODUL[ad]) return;
      kok.dataset.fsKuruldu = '1';
      try { MODUL[ad](kok); } catch (e) { if (W.console) console.error('[FS ' + ad + ']', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { baslat(document); });
  } else {
    baslat(document);
  }

  // tema düzenleyicide bölüm yeniden yüklendiğinde
  document.addEventListener('shopify:section:load', function (ev) { baslat(ev.target); });
})();
